<template>
  <div v-if="isDevMode" class="z-100000 bg-gray-200 text-gray-900 px-2">
    <div class="xs:hidden">
      none
    </div>
    <div class="hidden xs:block sm:hidden">
      xs
    </div>
    <div class="hidden sm:block md:hidden">
      sm
    </div>
    <div class="hidden md:block lg:hidden">
      md
    </div>
    <div class="hidden lg:block xl:hidden">
      lg
    </div>
    <div class="hidden xl:block">
      xl
    </div>
  </div>
</template>

<script setup>
const isDevMode = import.meta.env.DEV;
</script>
